import { create } from "zustand";
import { Vector3 } from "three";
import { ScreenPosition } from "./hoveredEditHandleStore";

export interface HoveredRoomNoteState {
    note: string | null;
    position: Vector3 | null;   // World position of the hovered note icon
    screenPosition: ScreenPosition | null;

    setHoveredRoomNote: (note: string, position: Vector3) => void;
    setScreenPosition: (screenPosition: ScreenPosition) => void;
    clearHoveredRoomNote: () => void;
}

export const useHoveredRoomNoteStore = create<HoveredRoomNoteState>()(
    (set) => ({
        note: null,
        position: null,
        screenPosition: null,

        setHoveredRoomNote: (note: string, position: Vector3) =>
            set({ note, position }),

        setScreenPosition: (screenPosition: ScreenPosition) =>
            set({ screenPosition }),

        clearHoveredRoomNote: () =>
            set({ note: null, position: null, screenPosition: null }),
    })
);
